import { render, staticRenderFns } from "./docx.vue?vue&type=template&id=4065a2fa&scoped=true"
import script from "./docx.vue?vue&type=script&lang=js"
export * from "./docx.vue?vue&type=script&lang=js"
import style0 from "./docx.vue?vue&type=style&index=0&id=4065a2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4065a2fa",
  null
  
)

export default component.exports